import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["disabled", "aria-label"]
const _hoisted_2 = ["data-qa"]
const _hoisted_3 = {
  key: 0,
  class: "_ml-1",
  "data-qa": "project-card:NumberOfFollowers"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("button", {
    disabled: $options.isFollowButtonDisabled(),
    type: "button",
    class: _normalizeClass(['gfu-project-card-stamp', 'gfu-project-card-follow', $options.buttonClasses]),
    "aria-label": $options.buttonAriaLabel,
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onClick && $options.onClick(...args)), ["prevent","stop"])),
    "data-qa": "project-card:FollowButton"
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(['gfu-project-card-follow__icon _ga _ga--heart-solid-icon', { 'gfu-project-card-follow__icon--followed': $options.isFollower }]),
      "data-qa": `is-follower:${$options.isFollower}`
    }, null, 10 /* CLASS, PROPS */, _hoisted_2),
    ($options.followersFormatted)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($options.followersFormatted), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}